













































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import rest from "@/rest";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { vuex } from "@/store";

interface SubtitleVm {
  label: string;
  source: string;
  languageCode: string;
}

@Component
export default class ManageSubtitles extends Vue {
  @Prop({ required: true }) audioFile!: string;
  @Prop({ default: false }) showDialog!: boolean;

  subtitles: SubtitleVm[] = [];
  busyOnCreate = false;
  selectedLanguage: SubtitleVm | null = { label: "", source: "", languageCode: "" };

  languageOptions: SubtitleVm[] = [
    { label: "Albanisch", source: "", languageCode: "sq" },
    { label: "Bulgarisch", source: "", languageCode: "bg" },
    { label: "Dänisch", source: "", languageCode: "da" },
    { label: "Deutsch", source: "", languageCode: "de" },
    { label: "Englisch", source: "", languageCode: "en" },
    { label: "Estnisch", source: "", languageCode: "et" },
    { label: "Finnisch", source: "", languageCode: "fi" },
    { label: "Französisch", source: "", languageCode: "fr" },
    { label: "Georgisch", source: "", languageCode: "ka" },
    { label: "Italienisch", source: "", languageCode: "it" },
    { label: "Kroatisch", source: "", languageCode: "hr" },
    { label: "Lettisch", source: "", languageCode: "lv" },
    { label: "Litauisch", source: "", languageCode: "lt" },
    { label: "Niederländisch", source: "", languageCode: "nl" },
    { label: "Norwegisch", source: "", languageCode: "no" },
    { label: "Polnisch", source: "", languageCode: "pl" },
    { label: "Portugiesisch", source: "", languageCode: "pt" },
    { label: "Rumänisch", source: "", languageCode: "ro" },
    { label: "Russisch", source: "", languageCode: "ru" },
    { label: "Schwedisch", source: "", languageCode: "sv" },
    { label: "Serbisch", source: "", languageCode: "sr" },
    { label: "Slowakisch", source: "", languageCode: "sk" },
    { label: "Slowenisch", source: "", languageCode: "sl" },
    { label: "Spanisch", source: "", languageCode: "es" },
    { label: "Tschechisch", source: "", languageCode: "cs" },
    { label: "Ukrainisch", source: "", languageCode: "uk" },
    { label: "Ungarisch", source: "", languageCode: "hu" }
  ];
  filteredLanguageOptions: SubtitleVm[] = [];

  mounted() {
    this.loadSubtitles();
  }

  async loadSubtitles() {
    if (!this.audioFile) return;
    this.subtitles = await rest.url("exercises/getSubtitles").query({ audioFile: this.audioFile }).get();
    this.filteredLanguageOptions = this.languageOptions.filter(
      lang => !this.subtitles.some(sub => sub.languageCode === lang.languageCode)
    );
  }

  getLanguageName(code: string) {
    const found = this.languageOptions.find(l => l.languageCode === code);
    return found ? found.label : code;
  }

  getFileName(filePath: string): string {
    return this.$globalHelper.extractFileName(filePath);
  }

  async createNewSubtitle() {
    if (!this.selectedLanguage?.languageCode) {
      vuex.ux.SB_FAILURE({
        message: "Bitte eine Sprache auswählen.",
        timeout: 3000
      });

      return;
    }
    if (!this.subtitles || this.subtitles.length == 0)  return;

    this.busyOnCreate = true;

    let subtitle = this.subtitles.find(s => s.languageCode === "de");
    if (!subtitle) {
      subtitle = this.subtitles.find(s => s.languageCode === "en");
    }
    if (!subtitle) {
      subtitle = this.subtitles[0];
    }

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SubtitleFile"] = subtitle.source;
    params.dictionary!["LanguageCode"] = this.selectedLanguage.languageCode;
    params.dictionary!["LanguageName"] = this.selectedLanguage.label;

    try {
      const newSubtitle = await rest.url("contentmanager/createNewSubtitle").post(params);
      console.log("newSubtitle", newSubtitle);
      if (newSubtitle && typeof newSubtitle === "string" && !newSubtitle.includes("error")) {
        this.subtitles.push({
          label: this.selectedLanguage!.label,
          source: newSubtitle,
          languageCode: this.selectedLanguage!.languageCode
        });
        this.filterLanguageOptions();
        this.$emit("changed:manageSubtitles");
        vuex.ux.SB_SUCCESS({
          message: `Neuer Untertitel in ${this.selectedLanguage!.label} erstellt.`,
          timeout: 2000
        });
      }
    } finally {
      this.busyOnCreate = false;
    }
  }

  onDelete(subtitle) {
    rest.url("contentmanager/deleteSubtitle")
      .query({ subtitleFile: subtitle.source })
      .delete()
      .then(() => {
        vuex.ux.SB_SUCCESS({
          message: `Untertitel in ${this.getLanguageName(subtitle.languageCode)} gelöscht.`,
          timeout: 2000
        });

        this.removeSubtitleFromList(subtitle);
      })
      .catch(() => {
      });
  }

  removeSubtitleFromList(subtitle) {
    const index = this.subtitles.indexOf(subtitle);
    if (index > -1) {
      this.subtitles.splice(index, 1);
    }

    this.filterLanguageOptions();
    this.$emit("changed:manageSubtitles");
  }

  filterLanguageOptions() {
    this.filteredLanguageOptions = this.languageOptions.filter(
      lang => !this.subtitles.some(sub => sub.languageCode === lang.languageCode)
    );
    this.selectedLanguage = { label: "", source: "", languageCode: "" };
  }

  onCancel() {
    this.$emit("update:showDialog", false);
  }
}
